import React, { useContext, useEffect, useState } from "react";
import { GlobalSubheader } from "../../components/subHeader/GlobalSubheader";
import { DefaultPageContainer } from "../../components/layoutContainer/styles/LayoutContainer";
import { CircularProgress, IconButton } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { GlobalContext } from "../../contexts/GlobalContext";
import { notify } from "../../utils/notify";
import { DialogConfirm } from "../customerManagements/children/DialogConfirm";
import Loading from "../../components/basics/Loading";
import { getEntitySystems } from "../../repositories/portal_api/Systems";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { TabsStyled, TabStyled } from "./styles/ConectaZapPage";
import { addInstance } from "./service/ConectaZapService";
import { ConectaZapContext } from "./context/ConectaZapContext";
import TabPanelAccounts from "./components/TabPanelAccounts";
import TabPanelBlockedNumbers from "./components/TabPanelBlockedNumbers";
import TabDefaultMessages from "./components/TabDefaultMessages";

const ConectaZapPage = ({ ...props }) => {
  const [loading, setLoading] = useState(true);
  const [showAddInstance, setShowAddInstanceDialog] = useState(false);
  const [currentTab, setCurrentTab] = useState(0);
  const { companyUser } = useContext(GlobalContext);
  const { loadingPage } = useContext(ConectaZapContext);

  const { replace } = useHistory();
  useEffect(() => {
    async function initialSetup() {
      setLoading(true);

      const responseSystems = await getEntitySystems();
      let hasConectaZap = false;

      if (responseSystems?.success) {
        responseSystems?.data.forEach((system) => {
          if (system?.system_id === 20 && system?.status === "A") {
            hasConectaZap = true;
          }
        });
      }

      if (!hasConectaZap) {
        notify("Você não possui o produto WhatsApp", true, "error");
        setLoading(false);
        replace("/dashboard/view");
        return;
      }

      setLoading(false);
    }
    initialSetup();
    // eslint-disable-next-line
  }, []);

  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      <Loading open={loadingPage}></Loading>
      <GlobalSubheader title={"Whatsapp"} titleLocation={"/whatsapp"} />
      <DefaultPageContainer>
        <div
          style={{
            background: "#fff",
            border: "1px solid #E0E0E0",
            borderRadius: 15,
            padding: 16,
          }}
        >
          {loading ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress />
            </div>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  borderBottom: "1px solid #CECFD0",
                }}
              >
                <TabsStyled
                  value={currentTab}
                  onChange={(ev, value) => {
                    setCurrentTab(value);
                  }}
                >
                  <TabStyled value={0} label="Contas" />
                  <TabStyled value={1} label="Mensagens Padrão" />
                  <TabStyled value={2} label="Números Bloqueados" />
                </TabsStyled>
                {currentTab === 0 && (
                  <div style={{ display: "flex" }}>
                    <IconButton
                      size="small"
                      style={{
                        alignSelf: "center",
                        background: "#0036B3",
                        color: "#fff",
                      }}
                      onClick={() => {
                        setShowAddInstanceDialog(true);
                      }}
                    >
                      <Add></Add>
                    </IconButton>
                  </div>
                )}
              </div>

              {currentTab === 0 && <TabPanelAccounts></TabPanelAccounts>}

              {currentTab === 1 && <TabDefaultMessages></TabDefaultMessages>}

              {currentTab === 2 && (
                <TabPanelBlockedNumbers></TabPanelBlockedNumbers>
              )}
            </>
          )}
        </div>
      </DefaultPageContainer>

      <DialogConfirm
        title={"Adicionar Conta"}
        description={
          "Você deseja adicionar uma nova conta para utilização do WhatsApp?"
        }
        handleClose={() => {
          setShowAddInstanceDialog(false);
        }}
        handleConfirm={async () => {
          setShowAddInstanceDialog(false);
          await addInstance(companyUser.document);
        }}
        open={showAddInstance}
      ></DialogConfirm>
    </div>
  );
};

export default ConectaZapPage;
